import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect } from "../../../components/hooks";
import { MemberAPI } from "../../../axios/api";

import { option_category } from "../../../service/option";

import { Button } from "primereact/button";

export default function ModulePopKnowledgeDetail({
  prePopOption,
  closePrePop,
}) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState([]);

  useAbortedEffect(
    (signal) => {
      dispatch(setProgress(true));

      let params = {
        memberid: prePopOption.memberid,
      };

      MemberAPI.getKnowledgesCountsRecordDataMyMemberid({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          let options = option_category.knowledge.reduce(
            (pre, cur) => ({
              ...pre,
              [cur.type]: cur,
            }),
            {}
          );

          data = Object.entries(data ?? {}).map(([type, count]) => ({
            type,
            title: options[type]?.label ?? "",
            count,
          }));
          setApiData(data);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [prePopOption]
  );

  return (
    <>
      <div className="px-3">
        <table className="w-full custom-tb text-center">
          <thead>
            <tr className="bg-blue-50">
              <th className="p-2">類型</th>
              <th className="p-2">瀏覽次數</th>
            </tr>
          </thead>
          <tbody>
            {apiData.map((item) => (
              <tr className="font-bold">
                <td className="bg-orange-50 p-2">{item.title}</td>
                <td className="p-2">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-center mt-4">
          <Button
            className="p-button-secondary p-button-sm px-3"
            type="button"
            label="關閉"
            onClick={() => closePrePop({ type: prePopOption.type })}
          />
        </div>
      </div>
    </>
  );
}
